import { Card, Grid, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from 'react';
import { PhoneStatisticsService } from "../../services/PhoneStatisticsService";
import { LocalStorage, UtilityService } from "../../services/UtilityService";
import { appNote, pageTitles, ToasterTexts, ViewTextLabels } from "../shared/constants";
import DashboardCard from "./dashboard-card.component";
import Statistics from "./statistics-chart.component";
import { useDispatch, useSelector } from 'react-redux';
import PullToRefresh from 'react-simple-pull-to-refresh';
import { UpdateOrgPlanMetrics, UpdatePlanMetrics, UpdateuserPlanTracker } from '../../actions';
import { setHeaderTitle, setRefreshHandler } from "../../helpers/header.helper";
import { CreditsUsedIcon, DashboardIcon, MessageGroupIcon, MessageReceiveIcon, MessageSentIcon, StatsIcon, TelephoneIcon } from '../../icon';
import { DashboardType } from '../../models/dashboard.model';
import { mapToUsageModel, OrgPlanTracker, PlanMetrics, UserPlanTracker } from '../../models/plan-metrics.model';
import { ProfileModel } from '../../models/profile.model';
import { isMobileDevice, isTeamsApp, loadingProfile, planMetrics, showingAlert } from '../../selectors/selectors';
import { UserService } from '../../services/UserService';
import * as selector from '../../selectors/selectors';
import { PhoneNumbergroup, PhoneNumberModel } from '../../models/phone-number.model';
import setToast from '../../helpers/toaster.helper';
import { ToasterType } from '../shared/toaster/toaster.model';
import AnimateLoader from "../shared/loaders/animate-loader.component";
import messagsLogsLoader from "../shared/loaders/message-logs-search-inprogress-loader.json";
import { PhoneNumberService } from '../../services/PhonenumberService';
import ProfileNameLoader from '../shared/loaders/textbox-loader.json';
import PageHeader from "../shared/page-header.component";
import TierCard from "./tier-dashboard.component";
import { UserModel } from "../../models/users.model";

interface Props {
    [key: string]: any;
}

const DashboardComponent = (props: Props) => {
    const dispatch = useDispatch()

    const IsMobileDevice: boolean = useSelector(isMobileDevice)
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)
    const IsTeamsApp: boolean = useSelector(isTeamsApp)
    const LoadingProfile: boolean = useSelector(loadingProfile)
    const ShowingAlert: boolean = useSelector(showingAlert)
    const Profile: ProfileModel = UserService.getCurrentUserFromLocalStorage()
    const PlanMetrics: PlanMetrics = useSelector(planMetrics)
    const IsSignalRConnected: boolean = useSelector(selector.IsSignalRConnected)
    const IsNewOrgFlow: boolean = useSelector(selector.isNewOrgFlow);
    const UserPlanTracker: UserPlanTracker = useSelector(selector.userPlanTracker)
    const PhoneNumberGroups: PhoneNumbergroup[] = useSelector(selector.phonenumbergroups);
    const Users: UserModel[] = useSelector(selector.users);

    const [loading, setLoading] = useState<boolean>(false)
    // const [messageSent, setMessageSent] = useState<string>("")
    // const [messageRecieved, setMessageRecieved] = useState<string>("")
    const [chartData, setChartData] = useState<any>([])
    const [showToolTip, setShowToolTip] = useState<boolean>(true)
    const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers)
    const [inputValue, setInputValue] = useState(false);
    const [value, setvalue] = useState(UtilityService.maskPhoneNumberOnLength(Profile?.PhoneNumber));
    const [secondaryPhoneNumbers, setSecondaryPhoneNumbers] = useState(UserService.getCurrentUserFromLocalStorage()?.SecondaryPhoneNumbers || []);
    const [IsLoading, SetIsLoading] = useState<boolean>(false);
    const [loader, setLoader] = useState(false);
    const [phoneNumbersUnReadCount, setPhoneNumbersUnReadCount] = useState<{ phoneNumber: string; phoneNumberId: string; unreadCount: number }[]>([]);


    useEffect(() => {
        setHeaderTitle(pageTitles.DASHBOARD);
        setRefreshHandler(refreshData);
        refreshData();
        return () => {
            setRefreshHandler()
            setHeaderTitle()
        }
    }, [])

    useEffect(() => {
        setSecondaryPhoneNumbers(UserService.getCurrentUserFromLocalStorage()?.SecondaryPhoneNumbers || [])
    }, [Users])

    const refreshData = () => {
        setLoading(true)
        if (!IsNewOrgFlow) {
            PhoneStatisticsService.getPhonebyNum(Profile.PhoneNumberID)
                .then((res) => {
                    let loggedInUser = JSON.parse(localStorage.getItem('current-user'));
                    loggedInUser.planTracker = res.data.tracker;
                    localStorage.setItem('current-user', JSON.stringify(loggedInUser));
                    UpdatePlanMetrics(dispatch, res.data.tracker);
                    let statistics = updateStatistics(res.data.statistics);
                    setChartData(statistics)
                    setLoading(false)
                }).catch(err => {
                    console.log("err", err)
                    setLoading(false)
                })
        } else {
            PhoneStatisticsService.getStatisticsByPhoneId(Profile.PhoneNumberID).then((res) => {
                let loggedInUser = JSON.parse(localStorage.getItem('current-user'));
                loggedInUser.userPlanTracker = res.data.userTracker;
                loggedInUser.orgPlanTracker = res.data.orgTracker;
                localStorage.setItem('current-user', JSON.stringify(loggedInUser));
                let statistics = updateStatistics(res.data.statistics);
                setChartData(statistics)
                UpdateuserPlanTracker(dispatch, res.data.userTracker)
                UpdateOrgPlanMetrics(dispatch, res.data.orgTracker)
                setLoading(false)
            }).catch((err) => {
                setLoading(false)
            })
        }
    }

    const updateStatistics = (statistics: any) => {
        var data: any[] = [], min: any = "";
        Object.keys(statistics).forEach((key: any) => {
            var date = new Date(key);
            if (!min)
                min = date;
            if (!now || min < date)
                now = date;
            var values = statistics[key];
            if (!data.filter((x: any) => x.date.getMonth() === date.getMonth()
                && x.date.getDate() === date.getDate() && x.date.getYear === date.getFullYear()).length)
                data.push({ date: new Date(date), sent: values.sent, received: values.received })
        })
        min = !min ? UtilityService.getPreferredTimeZoneTimeNow() : new Date(min.setDate(min.getDate() + 1));
        var now = UtilityService.getPreferredTimeZoneTimeNow();
        now.setHours(23, 59, 59);
        while (min <= now) {
            if (!data.filter((x: any) => x.date.getMonth() === min.getMonth()
                && x.date.getDate() === min.getDate() && x.date.getYear() === min.getYear()).length)
                data.push({ date: new Date(min), sent: 0, received: 0 });
            min = new Date(min.setDate(min.getDate() + 1));
        }
        data = data.sort((a: any, b: any) => (a.date - b.date));
        let labels = []
        data.map(sdate => labels.push({ date: sdate.date, sent: sdate.sent, receive: sdate.received }))
        let obj: any = {
            labels: [], datasets: [{
                "label": "Messages Sent",
                "backgroundColor": "rgba(75,192,192,1)",
                "yAxisID": "bar-stacked",
                "data": []
            }, {
                "label": "Messages Received",
                "backgroundColor": "#396AFF",
                "yAxisID": "bar-stacked",
                "data": []
            }]
        }

        //adding zero data for previous dates
        while (data.length < 30) {
            let date = UtilityService.getPreferredTimeZoneTimeNow();
            date.setDate(date.getDate() - data.length)
            data = [{ date, sent: 0, receive: 0 }, ...data];
        }

        data.map(label => {
            obj.labels.push(UtilityService.convertToDay(label.date))
            obj.datasets[0].data.push(label.sent || 0)
            obj.datasets[1].data.push(label.received || 0)
        });
        return obj;
    }


    const handleShow = (value: boolean) => {
        setInputValue(value);
        if (value) { PhoneNumberService.GetUnreadCount().then((res) => setPhoneNumbersUnReadCount(res.data)).catch((err) => err) }
    }

    const onSubmit = (e: any) => {
        e.preventDefault();
        setvalue(e.target.value)
        let orgroleID;
        PhoneNumbers.forEach((phoneNumber) => {
            if (phoneNumber.PhoneNumber === e.target.value) {
                orgroleID = phoneNumber.ID;
            }
        })
        let numberId;
        secondaryPhoneNumbers.forEach((phoneNumber) => {
            if (phoneNumber.phoneNumber === e.target.value) {
                numberId = phoneNumber.phoneNumberId;
            }
        })
        let updatedsecondaryphonenumbers = [];
        if (UserService.hasManagerRole() || UserService.hasUserRole()) {
            const filtered = PhoneNumbers.filter(x => x.PhoneNumber === UtilityService.unmaskPhoneNumberWithPlus(value));
            const name = filtered.length > 0 ? filtered[0].Name : null;
            // const index = secondaryPhoneNumbers.findIndex(phone => phone.phoneNumberId === numberId);
            // if (index !== -1) {
            //     secondaryPhoneNumbers[index] = { phoneNumberId: Profile.PhoneNumberID, phoneNumber: Profile.PhoneNumber, phoneNumberName: name }
            // }
            updatedsecondaryphonenumbers = [...secondaryPhoneNumbers.filter(x => x.phoneNumberId != numberId), { phoneNumberId: filtered[0].ID, phoneNumber: filtered[0].PhoneNumber, phoneNumberName: name }]
            setSecondaryPhoneNumbers(updatedsecondaryphonenumbers)
        }

        const profile = UserService.getCurrentUserFromLocalStorage();
        const group = PhoneNumberGroups.find(x => x.PhoneNumbers?.some(y => y.phoneNumberId === orgroleID));

        SetIsLoading(true);
        const obj: any = {
            "id": Profile.ID,
            "firstName": profile.FirstName,
            "lastName": profile.LastName,
            "email": Profile.Email,
            "organizationId": Profile.OrgId,
            "phoneNumberId": UserService.hasOrgAdminRole() ? orgroleID : numberId,
            "phoneNumber": e.target.value,
            "roleId": Profile.RoleID,
            "isDeleted": false,
            "secondaryPhoneNumbers": updatedsecondaryphonenumbers,
            "phonenumberGroups": UserService.hasManagerRole() ? Profile.phoneNumberGroups : group ? [{ id: group.Id, name: group.GroupName }] : [],
            "planId": LocalStorage.get("current-user")?.planId,
            "seatType": LocalStorage.get("current-user")?.seatType
        }
        UserService.updateUser(obj)
            .then(() => {
                setLoading(false)
                setToast(ToasterTexts.SWITCH_NUMBER, ToasterType.SUCCESS);
            })
            .catch((err) => {
                setToast(err.response.data.message, ToasterType.DANGER);
                setLoader(false)
                SetIsLoading(false)
                if (UserService.hasUserRole() || UserService.hasManagerRole()) {
                    setvalue(Profile.PhoneNumber);
                    setSecondaryPhoneNumbers(UserService.getCurrentUserFromLocalStorage().SecondaryPhoneNumbers)
                } else {
                    setvalue(Profile.PhoneNumber);
                }
            })
    }
    const pullToRefresh = () => new Promise((resolve) => setTimeout(resolve, 15)).then(() => UserService.getCurrentUserFromLocalStorage())

    return (
        <PullToRefresh isPullable={IsMobileDevice} pullingContent='' onRefresh={pullToRefresh} className='h-fit'>
            <Grid container className={`${IsMobileDevice ? 'px-2 pb-2 o-y-scroll' : IsTeamsApp ? "" : ""} h-p-100 o-x-hidden`} style={{ WebkitOverflowScrolling: 'touch', overflowX: 'auto' }}>
                {IsMobileDevice &&
                    <Grid item xs={12} >
                        <PageHeader
                            Reload={refreshData}
                            HeaderText={pageTitles.DASHBOARD}
                            HideSearch={true}
                            ShowFilterIcon={false} />
                    </Grid>}
                {PlanMetrics.DashboardType === DashboardType.TIER_ONE ?
                    <Grid item xs={12} className={`t-align-right ${IsMobileDevice ? 'mr-1' : 'mr-3'}  ${IsMobileDevice && IsTeamsApp ? 'mb-1' : 'mb-2'}`}>
                        {
                            LoadingProfile ?
                                <div className={"d-flex t-align-center c-pointer my-auto"}>
                                    <AnimateLoader LoaderAnimation={ProfileNameLoader} className="ml-auto w-28 h-3" />
                                </div> :
                                <div>
                                    <span className={`${IsMobileDevice ? 'h2 d-flex flex-direction' : 'h2-regular'}`}>
                                        {IsMobileDevice ?
                                            <div style={{ marginLeft: 'auto' }}>
                                                <Select
                                                    disabled={IsSignalRConnected}
                                                    value={UtilityService.maskPhoneNumberOnLength(value)}
                                                    onChange={(e) => { onSubmit(e); setLoader(true) }}
                                                    variant='standard'
                                                    classes={{ icon: "mr-1" }}
                                                    open={inputValue}
                                                    onOpen={() => handleShow(true)}
                                                    onClose={() => handleShow(false)}
                                                    className={"d-flex bg-color-switchui-background d-flex h-v-6 w-v-50 br-2"}
                                                    renderValue={(z) => {
                                                        const getName = PhoneNumbers.filter(x => x.PhoneNumber === UtilityService.unmaskPhoneNumberWithPlus(z)).map(x => x)
                                                        return (
                                                            <div className="d-flex">
                                                                <div className={`o-hidden p-1 align-center pl-2 ${IsDarkMode ? " color-nav-bar-font-color" : "color-switchUIoption"}`}>
                                                                    <div className="h5-regular ml-1 color-nav-bar-font-color">{z}</div>
                                                                    <div className="h5-regular color-nav-bar-font-color ml-1" style={{ textAlign: 'left' }}>{UtilityService.trimMessage(getName[0]?.Name, 15)}</div>
                                                                </div>
                                                                <div>
                                                                    <div className='pl-1 mt-2 w-3'>
                                                                        {loader && <AnimateLoader LoaderAnimation={messagsLogsLoader} />}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    }}
                                                    MenuProps={{
                                                        anchorOrigin: {
                                                            vertical: 'bottom',
                                                            horizontal: 'left',
                                                        },
                                                        transformOrigin: {
                                                            vertical: 'top',
                                                            horizontal: 'left',
                                                        },
                                                        PaperProps: {
                                                            style: {
                                                                maxHeight: '118px',
                                                                overflowY: 'auto',
                                                                display: UserService.hasOrgAdminRole()
                                                                    ? UtilityService.getFilteredPhoneNumbers(PhoneNumbers).length === 0 ? 'none ' : ""
                                                                    : UserService.hasUserRole() ? secondaryPhoneNumbers.length === 0 ? 'none' : "" : ''
                                                            },
                                                        },
                                                    }}
                                                >
                                                    {(UserService.hasUserRole() || UserService.hasManagerRole()) && secondaryPhoneNumbers.map((x) => (
                                                        <MenuItem className={"d-flex"} key={x.phoneNumberId} value={x.phoneNumber}>
                                                            <div className={`pl-1 ${IsDarkMode ? " color-nav-bar-font-color" : "color-switchUIoption"}`}>
                                                                <div className="d-flex justify-between w-p-100">
                                                                    <div className="h5-regular">{UtilityService.maskPhoneNumberOnLength(x.phoneNumber)}</div>
                                                                    {!!phoneNumbersUnReadCount.length && <span className={"lineswitcher-badge d-flex b-none r-1 w-3 h-3 br-p-50 bubble"}>
                                                                        <span className="m-auto" style={{ paddingTop: "2px" }}>
                                                                            {phoneNumbersUnReadCount.find((y) => y.phoneNumber === UtilityService.unmaskPhoneNumberWithPlus(x.phoneNumber))?.unreadCount || 0}
                                                                        </span>
                                                                    </span>}
                                                                </div>
                                                                <div className="h5-regular color-nav-bar-font-color">{UtilityService.trimMessage(x.phoneNumberName, 17)}</div>
                                                                <div className="border-top p-relative w-v-38"></div>
                                                            </div>
                                                        </MenuItem>
                                                    ))}
                                                    {UserService.hasOrgAdminRole() && UtilityService.getFilteredPhoneNumbers(PhoneNumbers).map((x) => (
                                                        <MenuItem className={"d-flex "} key={x.PhoneNumber} value={x.PhoneNumber}>
                                                            <div className={`${IsDarkMode ? " color-nav-bar-font-color" : "color-switchUIoption"}`}>
                                                                <div className="d-flex justify-between w-p-100">
                                                                    <div className="h5-regular w-p-85">{UtilityService.maskPhoneNumberOnLength(x.PhoneNumber)}</div>
                                                                    {!!phoneNumbersUnReadCount.length && <span className={"lineswitcher-badge d-flex b-none r-1 ml-1 w-p-13 h-p-100 br-p-50 bubble"}>
                                                                        <span className="m-auto" style={{ paddingTop: "2px" }}>
                                                                            {phoneNumbersUnReadCount.find((y) => y.phoneNumber === UtilityService.unmaskPhoneNumberWithPlus(x.PhoneNumber))?.unreadCount || 0}
                                                                        </span>
                                                                    </span>}
                                                                </div>
                                                                <div className="h5-regular color-nav-bar-font-color">{UtilityService.trimMessage(x.Name, 17)}</div>
                                                                <div className="border-top p-relative w-v-38"></div>
                                                            </div>
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </div>
                                            :
                                            ViewTextLabels.YOUR_NUMBER
                                        }
                                    </span>
                                    <span className={`${IsMobileDevice ? 'h3' : 'h2-semibold'}`}>{!IsMobileDevice && UtilityService.maskPhoneNumberOnLength(Profile.PhoneNumber)}</span>
                                </div>
                        }
                    </Grid> :
                    <div className={"mb-2"}>
                        <div className={"d-flex w-v-50"} style={{ float: 'left', width: '20%' }}></div>
                        <div className={"mr-1"} style={{ float: 'right', textAlign: 'right' }}>
                            {IsMobileDevice &&
                                <div className=''>
                                    <Select
                                        disabled={IsSignalRConnected}
                                        value={UtilityService.maskPhoneNumberOnLength(value)}
                                        onChange={(e) => (setvalue(e.target.value), onSubmit(e), setLoader(true))}
                                        variant='standard'
                                        classes={{ icon: "mr-1" }}
                                        open={inputValue}
                                        onOpen={() => handleShow(true)}
                                        onClose={() => handleShow(false)}
                                        className={"d-flex bg-color-switchui-background d-flex h-v-6 w-v-50 br-2 "}
                                        renderValue={(z) => {
                                            const getName = PhoneNumbers.filter(x => x.PhoneNumber === UtilityService.unmaskPhoneNumberWithPlus(z)).map(x => x)
                                            return (
                                                <div className="d-flex">
                                                    <div className="o-hidden p-1 align-center pl-2 color-switchUIoption">
                                                        <div className="h5-regular ml-1 color-nav-bar-font-color">{z}</div>
                                                        <div className="h5-regular color-nav-bar-font-color ml-1" style={{ textAlign: 'left' }}>{UtilityService.trimMessage(getName[0]?.Name, 15)}</div>
                                                    </div>
                                                    <div>
                                                        <div className='pl-1 mt-2 w-3'>
                                                            {loader && <AnimateLoader LoaderAnimation={messagsLogsLoader} />}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }}
                                        MenuProps={{
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left',
                                            },
                                            transformOrigin: {
                                                vertical: 'top',
                                                horizontal: 'left',
                                            },
                                            PaperProps: {
                                                style: {
                                                    maxHeight: '118px',
                                                    overflowY: 'auto',
                                                    display: UserService.hasOrgAdminRole()
                                                        ? UtilityService.getFilteredPhoneNumbers(PhoneNumbers).length === 0 ? 'none ' : ""
                                                        : UserService.hasUserRole() ? secondaryPhoneNumbers.length === 0 ? 'none' : "" : ''
                                                },
                                            },
                                        }}
                                    >
                                        {(UserService.hasUserRole() || UserService.hasManagerRole()) && secondaryPhoneNumbers.map((x) => (
                                            <MenuItem className={"d-flex"} key={x.phoneNumberId} value={x.phoneNumber}>
                                                <div className="pl-1 color-switchUIoption">
                                                    <div className="d-flex justify-between w-p-100">
                                                        <div className="h5-regular color-nav-bar-font-color">{UtilityService.maskPhoneNumberOnLength(x.phoneNumber)}</div>
                                                        {!!phoneNumbersUnReadCount.length && <span className={"lineswitcher-badge d-flex b-none r-1 w-3 h-3 br-p-50 bubble"}>
                                                            <span className="m-auto" style={{ paddingTop: "2px" }}>
                                                                {phoneNumbersUnReadCount.find((y) => y.phoneNumber === UtilityService.unmaskPhoneNumberWithPlus(x.phoneNumber))?.unreadCount || 0}
                                                            </span>
                                                        </span>}
                                                    </div>
                                                    <div className="h5-regular color-nav-bar-font-color">{UtilityService.trimMessage(x.phoneNumberName, 17)}</div>
                                                    <div className="border-top p-relative w-v-38"></div>
                                                </div>
                                            </MenuItem>
                                        ))}
                                        {UserService.hasOrgAdminRole() && UtilityService.getFilteredPhoneNumbers(PhoneNumbers).map((x) => (
                                            <MenuItem className={"d-flex "} key={x.PhoneNumber} value={x.PhoneNumber}>
                                                <div className="pl-1 color-switchUIoption">
                                                    <div className="d-flex justify-between w-p-100">
                                                        <div className="h5-regular color-nav-bar-font-color">{UtilityService.maskPhoneNumberOnLength(x.PhoneNumber)}</div>
                                                        {!!phoneNumbersUnReadCount.length && <span className={"lineswitcher-badge d-flex b-none r-1 w-3 h-3 br-p-50 bubble "}>
                                                            <span className="m-auto" style={{ paddingTop: "2px" }}>
                                                                {phoneNumbersUnReadCount.find((y) => y.phoneNumber === UtilityService.unmaskPhoneNumberWithPlus(x.PhoneNumber))?.unreadCount || 0}
                                                            </span>
                                                        </span>}
                                                    </div>
                                                    <div className="h5-regular color-nav-bar-font-color">{UtilityService.trimMessage(x.Name, 17)}</div>
                                                    <div className="border-top p-relative w-v-38"></div>
                                                </div>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </div>
                            }
                        </div>
                    </div>
                }
                {IsMobileDevice ?
                    <Grid container spacing={1} className={`px-1 h-v-80`} >
                        {/* <Grid container className={`bg-color-dashboard-box box-shadow-none br-3`}>
                        <Grid item xs={6} className={"d-flex p-2"}>
                            <p className={"dashboard-heading  my-auto"}> <span className={"h1"}>{appNote.HI}</span><span className={"color-primary-light h1"}> {props.Profile.FirstName}</span>, <br /> <span className={"dashboard-heading color-header-title-font"}> {appNote.WELCOME_TO_FALKON_SMS}</span> </p>
                        </Grid>
                        <Grid item xs={6}>
                            <DashboardMobileIcon className={"float-right p-2"} />
                        </Grid>
                        </Grid> */}
                        <Grid item xs={6} className={`${IsMobileDevice ? "d-flex pb-0 h-p-27" : "pl-0 pb-0 mt-1"}`}>
                            {PlanMetrics.DashboardType !== DashboardType.TIER_ONE ?
                                <DashboardCard ShowLoader={LoadingProfile || loading}
                                    CardColor={"bg-dashboard-phone"}
                                    avatar={<TelephoneIcon className={`w-2 mt-1 pr-2 ${!IsMobileDevice && "py-2"}`} />}
                                    title={"Your Phone Number"}
                                    body={UtilityService.maskPhoneNumberOnLength(Profile.PhoneNumber)}
                                    showToolTip={!showToolTip}
                                    IsMobileDevice={IsMobileDevice}
                                    IsTeamsApp={IsTeamsApp} /> :
                                <TierCard
                                    avatar={<CreditsUsedIcon className={`w-2 mt-1 pr-2 ${!IsMobileDevice && "py-2"}`} />}
                                    title={`${IsMobileDevice ? "1-1 Credits" : "1-1 Credits Used"}`}
                                    Data={PlanMetrics.NormalTextingUsage}
                                    IsMobileDevice={IsMobileDevice}
                                    IsTeamsApp={IsTeamsApp}
                                    ShowLoader={LoadingProfile || loading}
                                    CardColor={"bg-dashboard-phone"}
                                    ProgressTitle={`Credits Used`}

                                />}
                        </Grid>
                        <Grid item xs={6} className={`${IsMobileDevice ? "pb-0  h-p-27" : "pr-0 pb-0 mt-1"}`}>
                            <DashboardCard ShowLoader={LoadingProfile || loading} CardColor={"bg-dashboard-sent"} avatar={<MessageSentIcon className={`w-2 mt-1 pr-2 ${!IsMobileDevice && "py-2"}`} />} title="Sent" body={PlanMetrics.HasFreeIncome ? PlanMetrics.NormalTextingUsage.UsedCredits.toString() : (PlanMetrics.NormalTextingUsage.UsedCredits - PlanMetrics.ReceviedMessages).toString()} showToolTip={showToolTip} IsMobileDevice={IsMobileDevice} IsTeamsApp={IsTeamsApp} />
                        </Grid>
                        <Grid item xs={6} className={`${IsMobileDevice ? "pb-0  h-p-27" : "pl-0 pb-0 pt-0 mt-1"}`}>
                            <DashboardCard ShowLoader={LoadingProfile || loading} CardColor={"bg-dashboard-received"} avatar={<MessageReceiveIcon className={`w-2 mt-1 pr-2 ${!IsMobileDevice && "py-2"}`} />} title="Received" body={IsNewOrgFlow ? UserPlanTracker.Received.toString() : PlanMetrics.ReceviedMessages.toString()} showToolTip={showToolTip} IsMobileDevice={IsMobileDevice} IsTeamsApp={IsTeamsApp} />

                        </Grid>
                        <Grid item xs={6} className={`${IsMobileDevice ? "pb-0  h-p-27" : "pr-0 pb-0 pt-0 mt-1"}`}>
                            {PlanMetrics.DashboardType === DashboardType.TIER_THREE ?
                                <DashboardCard ShowLoader={LoadingProfile || loading} CardColor={"bg-dashboard-group"} avatar={<MessageGroupIcon className={`w-2`} />} title="Group" body={PlanMetrics.GroupCreditsUsage.UsedCredits.toString()} showToolTip={showToolTip} IsMobileDevice={IsMobileDevice} IsTeamsApp={IsTeamsApp} />
                                :
                                <TierCard
                                    avatar={<MessageGroupIcon className={`w-2 pr-2 mt-1 ${!IsMobileDevice && "py-2"}`} />}
                                    title="Group Credits "
                                    Data={IsNewOrgFlow ? mapToUsageModel(LocalStorage.get('current-user')?.orgPlanTracker?.groupMsgCredits) : PlanMetrics.GroupCreditsUsage}
                                    IsMobileDevice={IsMobileDevice}
                                    IsTeamsApp={IsTeamsApp}
                                    ShowLoader={LoadingProfile || loading}
                                    CardColor={"bg-dashboard-group"}
                                    ProgressTitle={`Group Credits`}
                                />}
                        </Grid>
                        <Grid item xs={12} className={`p-0`}>
                            <Statistics
                                ShowLoader={LoadingProfile || loading}
                                avatar={<StatsIcon className={`w-2`} />}
                                statistics={chartData}
                                IsMobileDevice={IsMobileDevice}
                                IsTeamsApp={IsTeamsApp}
                            />
                        </Grid>
                    </Grid>
                    : <Grid container spacing={2} className={`${PlanMetrics.DashboardType === DashboardType.TIER_ONE ? `h-v-${ShowingAlert ? 79 : 82}` : 'h-v-88'} o-y-scroll px-2`} >
                        <Grid item lg={12} xl={12} md={12}>
                            <Card className={"bg-color-dashboard-box box-shadow-none"}>
                                <Grid container >
                                    <Grid item xs={9} className={"d-flex pl-8"}>
                                        <div className={"dashboard-sms-heading my-auto "} style={{ color: "black" }}> {appNote.HI} <span className={"color-primary-light w-break"}>{Profile.FirstName}</span>,  <div className={"dashboard-heading"}>{appNote.WELCOME_TO_FALKON_SMS}</div> </div>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <DashboardIcon className={"float-right w-p-100 py-2"} />
                                    </Grid>
                                </Grid>
                            </Card>
                        </Grid>
                        <Grid item lg={3} md={3} sm={6} xs={12}>
                            {PlanMetrics.DashboardType !== DashboardType.TIER_ONE ?
                                <DashboardCard ShowLoader={LoadingProfile || loading} CardColor={"bg-dashboard-phone"} tooltip={""} avatar={<TelephoneIcon />} title={"Your Phone Number"} body={UtilityService.maskPhoneNumberOnLength(Profile.PhoneNumber)} showToolTip={!showToolTip} IsMobileDevice={IsMobileDevice} IsTeamsApp={IsTeamsApp} /> :
                                <TierCard
                                    avatar={<CreditsUsedIcon />}
                                    title="1-1 Credits Used"
                                    tooltip={PlanMetrics.HasOverQuota ? "Charges apply: 1 Over Quota credit = $0.04" : "Number of 1-1 credits used this month"}
                                    Data={PlanMetrics.NormalTextingUsage}
                                    IsMobileDevice={IsMobileDevice}
                                    IsTeamsApp={IsTeamsApp}
                                    ShowLoader={LoadingProfile || loading}
                                    CardColor={"bg-dashboard-phone"}
                                    ProgressTitle={`Credits Used`}
                                />}
                        </Grid>
                        <Grid item lg={3} md={3} sm={6} xs={12}>
                            <DashboardCard ShowLoader={LoadingProfile || loading} CardColor={"bg-dashboard-sent"} avatar={<MessageSentIcon />} tooltip="Number of 1-1 messages sent this month" title="Sent" body={PlanMetrics.HasFreeIncome ? PlanMetrics.NormalTextingUsage.UsedCredits.toString() : (PlanMetrics.NormalTextingUsage.UsedCredits - PlanMetrics.ReceviedMessages).toString()} showToolTip={showToolTip} IsMobileDevice={IsMobileDevice} IsTeamsApp={IsTeamsApp}
                            ></DashboardCard>

                        </Grid>
                        <Grid item lg={3} md={3} sm={6} xs={12} >
                            <DashboardCard ShowLoader={LoadingProfile || loading} CardColor={"bg-dashboard-received"} avatar={<MessageReceiveIcon />} tooltip="Number of messages received this month" title="Received" body={IsNewOrgFlow ? UserPlanTracker.Received.toString() : PlanMetrics.ReceviedMessages.toString()} showToolTip={showToolTip} IsMobileDevice={IsMobileDevice} IsTeamsApp={IsTeamsApp} />

                        </Grid>
                        <Grid item lg={3} md={3} sm={6} xs={12}>
                            {PlanMetrics.DashboardType === DashboardType.TIER_THREE ?
                                <DashboardCard ShowLoader={LoadingProfile || loading} CardColor={"bg-dashboard-group"} avatar={<MessageGroupIcon />} tooltip="Number of group credits used this month" title="Group" body={PlanMetrics.GroupCreditsUsage.UsedCredits.toString()} showToolTip={showToolTip} IsMobileDevice={IsMobileDevice} IsTeamsApp={IsTeamsApp} />
                                :
                                < TierCard
                                    avatar={<MessageGroupIcon />}
                                    title="Group Credits Used"
                                    tooltip={PlanMetrics.HasOverQuota ? "Charges apply: 1 Over Quota credit = $0.04" : "Number of group credits used this month"}
                                    Data={IsNewOrgFlow ? mapToUsageModel(LocalStorage.get('current-user')?.orgPlanTracker?.groupMsgCredits) : PlanMetrics.GroupCreditsUsage}
                                    IsMobileDevice={IsMobileDevice}
                                    IsTeamsApp={IsTeamsApp}
                                    ShowLoader={LoadingProfile || loading}
                                    CardColor={"bg-dashboard-group"}
                                    ProgressTitle={`Group Credits Used`}

                                />}
                        </Grid>
                        <Grid item xs={12}>
                            <Statistics
                                ShowLoader={LoadingProfile || loading}
                                avatar={<StatsIcon />}
                                statistics={chartData}
                                IsMobileDevice={IsMobileDevice}
                                IsTeamsApp={IsTeamsApp}
                            />
                        </Grid>
                    </Grid>
                }
            </Grid >
        </PullToRefresh >
    )
}

export default DashboardComponent;